import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';

interface Props {
  pd: number,
  onChange: (pd: number) => void,
}

export default ((props) => {
  const [pd, setPd] = useState<number>(props.pd);

  const handleChange = (value: number) => {
    setPd(value);
    props.onChange(value);  
  }

  return (
    <TextField value={pd} onChange={(e) => handleChange(Number(e.target.value))} />
  );
}) as React.FC<Props>;
